<template>
    <div class="form-group">
        <label>Missä?</label>
        <multiselect
            @select="onSelect"
            :options="cityOptions"
            :searchable="true"
            track-by="id"
            label="name"
            :options-limit="400"
            :allow-empty="false"
            placeholder="Valitse kunta"
            selectLabel=""
            deselectLabel=""
            selectedLabel=""
            :show-no-results="false"
            :hide-selected="false"
            :value="selectedCity">
            <span slot="noResult"></span>
        </multiselect>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect';

    export default {
        model: {
            prop: 'selectedCity',
            event: 'change'
        },
        components: {
            Multiselect
        },
        props: {
            cityOptions: {
                type: Array
            },
            selectedCity: {
                type: Object,
                required: false
            }
        },
        methods: {
            onSelect(city) {
                this.$emit('change', city);
            }
        }
    };
</script>
